import { useCallback, useState } from 'react';

export const useModal = () => {
    const [open, setOpenModal] = useState(false);

    const openModal = useCallback(() => {
        setOpenModal(true);
    }, []);

    const closeModal = useCallback(() => {
        setOpenModal(false);
    }, []);

    const toggleModal = useCallback(() => {
        setOpenModal(!open);
    }, [open]);

    return { open, openModal, closeModal, toggleModal };
};
